import { NameSmall, NameSmallProps } from '$admin/components/Member';

type Props = NameSmallProps;

export const User = (props: Props) => {
  return <NameSmall {...props} />;
};

User.displayName = 'Cell.User';